import { render, staticRenderFns } from "./CustomerCaseList.vue?vue&type=template&id=6b5868cf&scoped=true&"
import script from "./CustomerCaseList.vue?vue&type=script&lang=js&"
export * from "./CustomerCaseList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCaseList.vue?vue&type=style&index=0&id=6b5868cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5868cf",
  null
  
)

export default component.exports